export default __webpack_public_path__ + "static/media/occupational-fundamental-icon.e9baab86.svg";